
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { Utility } from '../../common/utility';
import { MdDialogRef } from '@angular/material';
import { DataEntryService } from './data-entry.service';
import { AppConstants } from '../../shared/constants/constants';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
    selector: 'data-entry',
    templateUrl: 'data-entry-popup.component.html',
    providers: [DataEntryService]
})

export class DataEntryPopupComponent implements OnInit {
    private dataEntryForm: FormGroup;
    // private utility = Utility;
    private userData = [];
    constructor(
        private utility: Utility,
        private formBuilder: FormBuilder,
        public dialogService: DialogService,
        private permissionService: PermissionService,
        private dataEntryService: DataEntryService,
        public dialogRef: MdDialogRef<DataEntryPopupComponent>) {
        this.createForm();
    }

    ngOnInit() {
        // call API to get impersonated  user
        this.dataEntryService.getImpersonatedUser().subscribe(
            result => {
                if (result) {
                    this.userData = result.json();
                }
            }
        );
    }

    createForm() {
        this.dataEntryForm = this.formBuilder.group({
            userId: [null, [Validators.required]]
        });
    }

    onSubmit() {
        if (this.dataEntryForm.valid) {
            // call API to get permission array
            // const param = {
            //     userId: this.dataEntryForm.controls.userId.value,
            // };
            // this.dataEntryService.toggleImpersonatedUserPermission(param).subscribe(
            //     result => {
            //         if (result) {
            //             const data = result.json();
            //             const permission = data['Permissions'];
            //             // save user permission on pages
            //             localStorage.setItem(AppConstants.localStorage.permissionOnPage, JSON.stringify(permission));
            //             // this.permissionService.setImpersonatedPermission(permission);
            //             this.permissionService.setPermissionOnPage(permission);
            //         }
            //     });
            // get impersonate user first name and last name to show in header
            const index = this.userData.findIndex(item => item.userId === this.dataEntryForm.controls.userId.value);
            let data = null;
            if (index >= 0) {
                data = this.userData[index];
            }
            this.onCloseDialog(data);
        }
    }

    onCloseDialog(data = null) {
        this.dialogRef.close(data);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/header/data-entry-popup.component.ts